import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Pic from 'core/components/ContentfulImage';

import {
	Frame,
	PlayWrapper
} from './thumbStyles';

import Play from 'core/icons/Play';

const VidThumb = ({ name, url, isCurrent, isLazy, ratio, soloItem }) => {
	return (
		<Fragment>
			<PlayWrapper>
				<Play />
			</PlayWrapper>
			<Frame isCurrent={isCurrent} ratio={ratio} soloItem={soloItem}>
				<Pic src={url} alt={name} title={name} lazy={isLazy} width="152" height="101" />
			</Frame>
		</Fragment>
	);
};

VidThumb.propTypes = {
	url: PropTypes.string.isRequired,
	name: PropTypes.string,
	isCurrent: PropTypes.bool,
	isLazy: PropTypes.bool,
	ratio: PropTypes.string,
	soloItem: PropTypes.bool,
};

export default VidThumb;
